"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingClientV3 = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class RecordingClientV3 extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseUrl = '/v3/projects/';
    }
    getSessions(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getSessionsCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesForSession(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, sessionKey } = request, body = tslib_1.__rest(request, ["projectId", "sessionKey"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/${sessionKey}/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPages(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitors(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitorsCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForSessions(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForPages(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPlayingToken(projectId, sessionKey, pageNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                sessionKey,
                pageNumber,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktalePlayingToken(projectId, sessionKey, pageNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                sessionKey,
                pageNumber,
                type: 'clicktale',
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktaleXStudioToken(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/xstudioToken`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.RecordingClientV3 = RecordingClientV3;
//# sourceMappingURL=recording.client.v3.js.map